// import { exists, DocumentDirectoryPath, mkdir, downloadFile, readFile, writeFile } from "react-native-fs";
// import { unzip } from "react-native-zip-archive";
import Constants from "../config/Constants";
import AppConfig from "../config/AppConfig";
import * as Helper from "./Helper";
import _ from "lodash";
import DebugLogger from "./DebugLogger";
import HomeworkUnitService from "../services/screens/homework/HomeworkUnitService";

const DocumentDirectoryPath = AppConfig.FILE_SERVER;

function loadData(homeworkId, done, fail) {
    if (done) {
        done();
    }
    //we just need the server to generate homework data
    /*
    HomeworkUnitService.zipAndDownloadHomeworkData(
        homeworkId,
        response => {
            DebugLogger.log("#DOWNLOAD# download request url done");
            if (done) {
                done();
            }
        },
        error => {
            DebugLogger.log("err", error);
            if (fail) {
                fail(error);
            }
        },
    );
    */
}

function getData(homeworkId, homeworkUnitId, done, fail) {
    try {
        HomeworkUnitService.getHomeworkUnitData(
            homeworkUnitId,
            response => {
                let jsonData = JSON.parse(response.data);
                if (done) {
                    done(jsonData);
                }
                DebugLogger.log("got data: ", jsonData);
            },
            error => {
                // handle your errors here
                DebugLogger.log("got error: ", error);
                if (fail) {
                    fail(error);
                }
            },
        );
        /*
        const filePath = `${getHomeworkPath(homeworkId)}${homeworkUnitId}/data.json`;
        fetch(filePath)
            .then(response => response.json())
            .then(jsonData => {
                // jsonData is parsed json object received from url
                if (done) {
                    done(jsonData);
                }
                DebugLogger.log("got data: ", jsonData);
            })
            .catch(error => {
                // handle your errors here
                DebugLogger.log("got error: ", error);
                if (fail) {
                    fail(error);
                }
            });
        */
    } catch (err) {
        DebugLogger.log("ERROR:", err);
        if (fail) {
            fail(err);
        }
    }
}

function getHomeworkPath(homeworkId) {
    var pathSegments = Helper.buildPathSegments(homeworkId);
    return `${DocumentDirectoryPath}${Constants.LOCAL_FILE_STORAGE.ROOT_PATH}homeworks/${pathSegments[0]}/${pathSegments[1]}/${homeworkId}/`;
}

function getHomeworkDoneFlagFilePath(homeworkId) {
    const pathSegments = Helper.buildPathSegments(homeworkId);
    return `${DocumentDirectoryPath}${Constants.LOCAL_FILE_STORAGE.ROOT_PATH}homeworks/${pathSegments[0]}/${pathSegments[1]}/${homeworkId}/extractDone.txt`;
}

// function getUserHomeworkPath(userHomeworkId, homeworkUnitId, childUnitIndex) {
//     var pathSegments = Helper.buildPathSegments(userHomeworkId);
//     return `${DocumentDirectoryPath}${Constants.LOCAL_FILE_STORAGE.ROOT_PATH}users/homeworks/${pathSegments[0]}/${pathSegments[1]}/${userHomeworkId}/${homeworkUnitId}/${childUnitIndex}/`;
// }

// only use for talkchinese for now
// we will remove it later.
const generateAudioFilePath = (assignmentId, userId, userHomeworkUnitId) => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now
        .getDate()
        .toString()
        .padStart(2, "0");

    const rootDir = Constants.LOCAL_FILE_STORAGE.TALK_CHINESE_ROOT_PATH;
    return `${rootDir}${year}/${month}/${day}/${assignmentId}/${userId}/${userHomeworkUnitId}/`;
};

const calcCompletedUnitCount = homeworkData => {
    if (homeworkData) {
        const { units } = homeworkData;
        if (units) {
            return _.filter(units, s => !!s.endOn).length;
        }
    }

    return 0;
};

const unitPassingScore = unit => {
    const spokenUnits = ["POKA1", "POKA2", "POKA3", "POKA4", "PSKA1"];
    if (spokenUnits.indexOf(unit.unitType) >= 0) {
        return AppConfig.UNIT_PASSING_SCORE;
    }
    // 非口语题小于100分要复习
    return 1;
};

//PSxx1-O may let you upload multiple pics ,so do no auto continue on this case
const isNotPoToPs = unitType => {
    return !_.endsWith(unitType, "-O");
}

const isUnitTypeContinueAutomatically = unitType => {
    return unitType.startsWith("PS") && unitType !== "PSKA5"  && unitType !== "PSSD2" && isNotPoToPs(unitType);
};

const shouldContinueAutomatically = unit => {
    let unitType = unit.unitType.toUpperCase();
    if (unitType === "PSSO1") {
        const i = unit.childUnitIndex;
        unitType = unit.data.practices[i].unitType;
    }

    if (!Helper.isNullOrEmpty(unitType)) {
        if (["POLA1"].includes(unitType) && isNotPoToPs(unitType)) {
            return true;
        }

        if (unit.data && unit.data.answerType && Helper.isNotDefaultAnswerType(unit.data.answerType)) {
            // 语音和拍照答案模式, 直接下一题
            return true;
        }

        if (unitType === "PSSD2") {
            // 简答题没有答案解释，直接下一题
            if (!unit.data) {
                return true;
            }

            if (!unit.data.answerReference) {
                return true;
            }
        }

        if (isUnitTypeContinueAutomatically(unitType)) {
            if (unit.data) {
                //abnormal answer type do not auto skip
                if (unit.data.answerType && Helper.isNotDefaultAnswerType(unit.data.answerType)){
                    return false;
                }

                let referenceAnswers = unit.data.referenceAnswers;

                let haveReferenceAnswers = false;
                referenceAnswers &&
                    referenceAnswers.map((item, i) => {
                        if (item && (item.text || item.image)) {
                            haveReferenceAnswers = true;
                        }
                    });

                if (!haveReferenceAnswers) {
                    let practices = unit.data.practices;
                    if (practices && practices.length > 0) {
                        for (let i = 0; i < practices.length; ++i) {
                            if (practices[i].referenceAnswer && (practices[i].referenceAnswer.text || practices[i].referenceAnswer.image)) {
                                haveReferenceAnswers = true;
                                break;
                            }
                        }
                    }
                }

                if (!haveReferenceAnswers) {
                    return true;
                }
            }
        }
    }

    return false;
};

export { loadData, getData, generateAudioFilePath, calcCompletedUnitCount, unitPassingScore, shouldContinueAutomatically };
